import React from 'react';
import PropTypes from 'prop-types';

import ReportCell from '../../../shared/agGrid/cellRenderers/ReportCell.component';

const ReportCellRenderer = ({ value }) => (
  <ReportCell type={value.type}>
    {value.data}
  </ReportCell>
);

ReportCellRenderer.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default ReportCellRenderer;
